import type { ClickToTextWidgetForm } from '@widgets/click-to-text/types'
import { phoneService } from '@widgets/shared/services/phoneService'
import clickToTextApiService from '@widgets/click-to-text/services/clickToTextApiService'
import translateService from '@widgets/shared/services/translate/translateService'
import type { Ref } from '@/composition/vue/compositionApi'
import type { ClickToTextWidgetState } from '@/components/domain/services/forms/clickToText/types'
import { useWidgetForm, type WidgetFieldsConfig } from '@/composition/widgetForm'
import { TmFakeCountryCode } from '@/services/types'

export const useClickToTextForm = (uniqueCode: string, widgetState: Ref<ClickToTextWidgetState>) => {
  const fieldsConfig: WidgetFieldsConfig<ClickToTextWidgetForm> = {
    name: {
      value: '',
      validate: (value) => (!value ? [translateService.t('errors.name')] : []),
    },
    countryCode: {
      value: TmFakeCountryCode,
    },
    phoneNumber: {
      value: '',
      validate: (value) => (!value ? [translateService.t('errors.phoneNumber')] : []),
    },
    message: {
      value: '',
      validate: (value) => (!value ? [translateService.t('errors.message')] : []),
    },
  }
  const submitCallback = async ({ name, message, phoneNumber, countryCode }) => {
    const payload = {
      name,
      message,
      phoneNumber: phoneService.preparePhoneWithCountryCodeForUpload(countryCode, phoneNumber),
    }
    await clickToTextApiService.sendMessage(uniqueCode, payload)
    widgetState.value = 'completed'
  }

  const widgetForm = useWidgetForm(fieldsConfig, submitCallback)

  return {
    ...widgetForm,
    fieldsConfig,
  }
}
